module.exports = __webpack_public_path__ + "img/collection-3.a445770a.png";